import { getOr } from 'lodash/fp';

import { DEVICE_API, API } from '@portals/redux';
import { setValue, updateData } from '@portals/redux/actions/data';

export const setAuth = setValue('dev', 'auth');

export const getApiDevice = (state) => getOr({}, 'data.dev.auth', state);

export const getDeviceInfo = (id) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}`,
    name: 'getDeviceInfo',
  },
});

export const updateDevice = (id, data) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}`,
    method: 'PUT',
    data,
    name: 'updateDevice',
  },
});

export const sendTelemetry = (
  id,
  data,
  accessToken = null,
  extraActions = null
) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/telemetry`,
    data,
    name: 'sendTelemetry',
    accessToken,
    success: extraActions,
  },
});

export const getConfig = (id) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/config`,
    name: 'getConfig',
  },
});

export const setConfig = (id, data) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/config`,
    data,
    name: 'setConfig',
  },
});

export const getCommand = (id) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/command`,
    name: 'getCommand',
  },
});

export const updateCommand = (id, data) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/command`,
    data,
    name: 'updateCommand',
  },
});

export const sendDump = (id, mimeType, filename, data) => ({
  type: DEVICE_API,
  payload: {
    method: 'POST',
    url: `v1/devices/${id}/dumps/${encodeURIComponent(mimeType)}/${filename}`,
    contentType: 'plain/text',
    data,
    name: 'sendDump',
  },
});

export const getLicenses = (id) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/licenses`,
    name: 'getLicenses',
  },
});

export const updateLicense = (id, data) => ({
  type: DEVICE_API,
  payload: {
    url: `v1/devices/${id}/licenses`,
    data,
    name: 'updateLicense',
  },
});

export const fetchStats = () => ({
  type: API,
  payload: {
    url: 'ui/partner/stats',
    success: updateData('stats'),
    name: 'fetchStats',
  },
});
